export type { FlavourFeatures, FlavourType } from './types';
export { hospitalityFeatures } from './hospitality';
export { residentialFeatures } from './residential';
export { commercialFeatures } from './commercial';

import type { FlavourFeatures, FlavourType } from './types';
import { hospitalityFeatures } from './hospitality';
import { residentialFeatures } from './residential';
import { commercialFeatures } from './commercial';

const FLAVOUR_MAP: Record<FlavourType, FlavourFeatures> = {
  hospitality: hospitalityFeatures,
  residential: residentialFeatures,
  commercial: commercialFeatures,
};

/**
 * Get feature flags for a given space category.
 * Falls back to residential if unknown — including for a site still stored
 * under a category the product no longer supports.
 */
export function getFlavourFeatures(spaceCategory?: string | null): FlavourFeatures {
  if (spaceCategory && spaceCategory in FLAVOUR_MAP) {
    return FLAVOUR_MAP[spaceCategory as FlavourType];
  }
  return residentialFeatures; // Safe default
}

/**
 * Get the flavour type string, defaulting to 'residential'
 */
export function getFlavourType(spaceCategory?: string | null): FlavourType {
  if (spaceCategory && spaceCategory in FLAVOUR_MAP) {
    return spaceCategory as FlavourType;
  }
  return 'residential';
}

/** GRMS owns the complete dashboard and its room-card rendering for hospitality. */
export function usesGrmsDashboard(flavour: FlavourType): boolean {
  return flavour === 'hospitality';
}
